"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
class ProfileCircleComponent {
    constructor() { }
    ngOnInit() { }
}
exports.ProfileCircleComponent = ProfileCircleComponent;
